import xhr from './xhr'

export default function getJSON (url) {
    return xhr({ url })
}
